import styled from 'styled-components';

export const Projects = styled.section`

    padding: 3rem 0;
    background-color: ${ props => props.theme.greyColor };

    @media (max-width: 1024px){
        padding: 3rem 1.5rem;
    }

    .container {

        .projects {

            display: flex;
            flex-wrap: wrap;

            .project {
                margin-left: 1rem;
                margin-bottom: 1rem;
                background-color: ${ props => props.theme.lightColor };
                width: 30%;
                padding: 1rem;
                text-align: center;

                @media (max-width: 768px){

                    width: 47%;

                    img {
                        height: 15rem;
                    }

                }

                @media (max-width: 500px){

                    width: 100%;
                    margin-left: 0;

                }

                img {
                    width: 100%;
                }

                h3 {
                    font-size: 1.2rem;
                    padding: 1rem 0;
                }

                p {
                    font-weight: 300;
                    margin-bottom: 1rem;
                }
            }

        }

    }

`